<template>
  <div class="home">
    <div class="shortBox">
      <el-row :gutter="34" class="shortList">
        <el-col :span="24">
          <el-row :gutter="34">
            <el-col :span="4" v-for="item in shortcutMenu" :key="item.id">
              <div class="shortcut bg" @click="shortcutMenuClick(item.path)">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="'#icon-'+ item.shortcut_icon"></use>
                </svg>
                <span>{{item.label}}</span>
              </div>
            </el-col>
            <!--<el-col :span="4" v-for="n in shortcutMenu.length%6 == 0?0:6-shortcutMenu.length%6" :key="n">
              <div class="shortcut bg" @click="isSetting">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-shezhi"></use>
                </svg>
                <span>点击设置</span>
              </div>
            </el-col>-->
          </el-row>
        </el-col>
      </el-row>
      <div class="shortBtn bg" @click="isSetting">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-category"></use>
        </svg>
      </div>
    </div>
    <div class="business">
      <el-row :gutter="34">
        <el-col :span="17">
          <div class="handler bg">
            <div class="handleTitle">
              <div>
                <span>业务办理中心</span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-category"></use>
                </svg>
              </div>
              <div class="handleTitle-right">
                <div class="state"><span>待处理</span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-Rightbutton"></use>
                  </svg>
                </div>
                <div class="state"><span>已处理</span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-Rightbutton"></use>
                  </svg>
                </div>
              </div>
            </div>
            <div class="handleBox">
              <div class="stageBox">
                <el-row :gutter="20">
                  <el-col :span="5"><h2>待处理</h2></el-col>
                  <el-col :span="19">
                    <div class="stageList">
                      <div class="stage" v-for="item in pendingLists[0]" :key="item">
                        <h3>{{item.count}}</h3>
                        <span>{{item.name}}</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-carousel trigger="click" height="200px" indicator-position="outside" interval="0" arrow="never">
                  <el-carousel-item v-for="pendingList in pendingLists" :key="pendingList">
                    <el-row :gutter="20" class="stageDetail">
                      <el-col :span="5" class="stageName"><p v-for="item in pendingList" :key="item">
                        {{item.company}}</p></el-col>
                      <el-col :span="19">
                        <div class="stageList" v-for="item in pendingList" :key="item">
                          <div class="stageEnd">
                            <template v-for="n in item.stage-1">
                              <div class="stagePass"></div>
                            </template>
                            <div class="stagepend"></div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!--<div class="handleBtn">-->
            <!--<span>-->
            <!--<svg class="icon" aria-hidden="true">-->
            <!--<use xlink:href="#icon-zuojiantou"></use>-->
            <!--</svg>-->
            <!--</span>-->
            <!--<span>-->
            <!--<svg class="icon" aria-hidden="true">-->
            <!--<use xlink:href="#icon-youjiantou"></use>-->
            <!--</svg>-->
            <!--</span>-->
            <!--</div>-->
          </div>
        </el-col>
        <el-col :span="7">
          <div class="bg monitor">
            <div class="handleTitle">
              <div>
                <span>业务监控</span>
              </div>
              <div class="handleTitle-right">
                <div class="state">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-Rightbutton-fill"></use>
                  </svg>
                </div>
              </div>
            </div>
            <div class="monitorLists">
              <div class="monitorList">
                <div class="monitorIcon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-tuding"></use>
                  </svg>
                </div>
                <div class="monitorDetail"><p class="mDTop"> 当月剩余未处理客户 <span>10</span> 家</p>
                  <p class="mDBottom"> 执行客户当月业务办理情况</p>
                </div>
              </div>
              <div class="monitorList">
                <div class="monitorIcon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-canjiren"></use>
                  </svg>
                </div>
                <div class="monitorDetail"><p class="mDTop"> 未上传残疾人证书 <span>10</span> 人</p>
                  <p class="mDBottom"> 为残疾人发薪，未上传相关证书</p>
                </div>
              </div>
              <div class="monitorList">
                <div class="monitorIcon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-zhongzhikehu"></use>
                  </svg>
                </div>
                <div class="monitorDetail"><p class="mDTop"> 未上传离职证明材料 <span>10</span> 人</p>
                  <p class="mDBottom"> 发放员工离职金，未上传相关证明材料</p>
                </div>
              </div>
              <div class="monitorList">
                <div class="monitorIcon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-liuzhiwaiguorenxukezheng"></use>
                  </svg>
                </div>
                <div class="monitorDetail"><p class="mDTop"> 未上传外籍人证明材料 <span>10</span> 人</p>
                  <p class="mDBottom"> 发放外籍人员工资，未上传相关证明材料</p>
                </div>
              </div>
              <div class="monitorList">
                <div class="monitorIcon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-shoukuan"></use>
                  </svg>
                </div>
                <div class="monitorDetail"><p class="mDTop"> 垫付未回款客户 <span>10</span> 人</p>
                  <p class="mDBottom"> 企业申请临时垫付，3天内未收到客户来款</p>
                </div>
              </div>
              <div class="monitorList">
                <div class="monitorIcon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-xinzengkehu"></use>
                  </svg>
                </div>
                <div class="monitorDetail"><p class="mDTop"> 人员报送异常 <span>10</span> 人</p>
                  <p class="mDBottom"> 系统自动报送人员到税局</p>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="customer">
      <el-row :gutter="20">
        <el-col :span="14">
          <div class="handler serviceBox bg">
            <div class="handleTitle">
              <div>
                <span>待服务客户</span>
              </div>
              <div class="handleTitle-center">
                <el-button-group>
                  <el-button :class="{'active':serviseActive == 0}" @click="changeTime(0)">今日</el-button>
                  <el-button :class="{'active':serviseActive == 1}" @click="changeTime(1)">本周</el-button>
                  <el-button :class="{'active':serviseActive == 2}" @click="changeTime(2)">本月</el-button>
                </el-button-group>
              </div>
              <div class="handleTitle-right">
                <div class="state">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-Rightbutton-fill"></use>
                  </svg>
                </div>
              </div>
            </div>
            <div class="serviceList">
              <el-row class="service" v-for="item in serviceList[0]" :key="item" :class="{zi:item.id==1,lan:item.id==2}"
                      v-show="serviseActive == 0">
                <el-col :span="1">{{item.index}}</el-col>
                <el-col :span="16" class="serviceName">{{item.name}}</el-col>
                <el-col :span="2">{{item.time}}</el-col>
                <el-col :span="2">{{item.advance}}</el-col>
                <el-col :span="3">{{item.state}}</el-col>
              </el-row>
              <el-row class="service" v-for="item in serviceList[1]" :key="item" :class="{zi:item.id==1,lan:item.id==2}"
                      v-show="serviseActive == 1">
                <el-col :span="1">{{item.index}}</el-col>
                <el-col :span="16" class="serviceName">{{item.name}}</el-col>
                <el-col :span="2">{{item.time}}</el-col>
                <el-col :span="2">{{item.advance}}</el-col>
                <el-col :span="3">{{item.state}}</el-col>
              </el-row>
              <el-row class="service" v-for="item in serviceList[2]" :key="item" :class="{zi:item.id==1,lan:item.id==2}"
                      v-show="serviseActive == 2">
                <el-col :span="1">{{item.index}}</el-col>
                <el-col :span="16" class="serviceName">{{item.name}}</el-col>
                <el-col :span="2">{{item.time}}</el-col>
                <el-col :span="2">{{item.advance}}</el-col>
                <el-col :span="3">{{item.state}}</el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="handler bg charts">
            <div class="handleTitle">
              <div>
                <span>客户行业分类</span>
              </div>
            </div>
            <div id="pie" class="chart">
            </div>
          </div>
        </el-col>
      </el-row>

    </div>
    <!--弹窗---------设置-------------->
    <div class="setting">
      <el-dialog
        width="700px"
        v-dialogDrag
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        lock-scroll
        title="设置"
        :visible.sync="setting"
        :before-close="handleClose">
        <div class="">
          <p class="shortSetTitle"><span>已选快捷菜单</span><span>（可拖拽调整显示顺序）</span></p>
          <draggable
            tag="ul"
            :list="shortcutMenu"
            class="list-group selectedItem"
            group="setItems"
          >
            <li
              class="list-group-item"
              v-for="element in shortcutMenu"
              :key="element.path"
            >
              <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-shanchu"></use>
                </svg>
              </span>
              <span class="text">{{ element.label }} </span>
            </li>
            <template v-if="shortcutMenu.length%6>0">
              <li  v-for="n in 6-shortcutMenu.length%6" :key="n"></li>
            </template>
          </draggable>
          <p class="shortSetTitle"><span>添加快捷菜单</span><span>（拖拽添加项目）</span></p>
          <draggable tag="ul" :list="shortcutMenus" class="list-group selectedItem" @end="end" :move="count"  group="setItems" >
            <li
              class="list-group-item"
              v-for="element in shortcutMenus"
              :key="element.path"
            >
              <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-shanchu"></use>
                </svg>
              </span>
              <span class="text">{{ element.label }} </span>
            </li>
            <template v-if="shortcutMenu.length%6>0">
              <li  v-for="n in 6-shortcutMenu.length%6" :key="n"></li>
            </template>
          </draggable>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="setting = false">取 消</el-button>
    <el-button type="primary" @click="saveSetting">确 定</el-button>
  </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  import draggable from "vuedraggable";
  import { getShortcutMenuByMemberId, saveShortcutMenu, getIndustryClass } from "@/api/home/home";
  import { dictFilter } from "@/filters/index";
  import { mapGetters } from "vuex";

  export default {
    name: "index",
    components: {
      draggable
    },
    computed: {
      textColor() {
        return this.$store.state.common.color;
      },
      ...mapGetters(["pms", "menu", "memberInfo", "dicts"])
    },
    mounted() {
      //  根据窗口大小调整图表大小
      window.onresize = () => {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById("pie"));
        myChart.resize();
      };
      // this.textColor = localStorage.getItem("Color");
      // this.$set(this, "textColor", this.textColor); //图表的字体颜色

      const pend = [
        [
          {
            id: 1,
            name: "薪资计算",
            count: 1,
            stage: 1,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 2,
            name: "客户账单",
            count: 1,
            stage: 2,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 3,
            name: "客户发票",
            count: 5,
            stage: 3,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 4,
            name: "来款认单",
            count: 2,
            stage: 4,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 5,
            name: "发放批次",
            count: 11,
            stage: 5,
            company: "沃奇卫士技术有限公司"
          }
        ], [
          {
            id: 1,
            name: "薪资计算",
            count: 1,
            stage: 1,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 2,
            name: "客户账单",
            count: 1,
            stage: 2,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 3,
            name: "客户发票",
            count: 5,
            stage: 3,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 4,
            name: "来款认单",
            count: 2,
            stage: 4,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 5,
            name: "发放批次",
            count: 11,
            stage: 5,
            company: "沃奇卫士技术有限公司"
          }
        ], [
          {
            id: 1,
            name: "薪资计算",
            count: 1,
            stage: 1,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 2,
            name: "客户账单",
            count: 1,
            stage: 2,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 3,
            name: "客户发票",
            count: 5,
            stage: 3,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 4,
            name: "来款认单",
            count: 2,
            stage: 4,
            company: "沃奇卫士技术有限公司"
          },
          {
            id: 5,
            name: "发放批次",
            count: 11,
            stage: 5,
            company: "沃奇卫士技术有限公司"
          }
        ]];
      const serviceList = [
        [
          {
            id: 1,
            index: "01",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "5日",
            advance: "提前",
            state: "未导入"
          },
          {
            id: 2,
            index: "02",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: " 数据导入"
          },
          {
            id: 3,
            index: "03",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "客户发票"
          },
          {
            id: 4,
            index: "04",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "数据导入"
          },
          {
            id: 5,
            index: "05",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "来款认单"
          },
          {
            id: 6,
            index: "06",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          },
          {
            id: 7,
            index: "07",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          },
          {
            id: 8,
            index: "08",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          }
        ], [
          {
            id: 1,
            index: "01",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "5日",
            advance: "提前",
            state: "未导入"
          },
          {
            id: 2,
            index: "02",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: " 数据导入"
          },
          {
            id: 3,
            index: "03",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "客户发票"
          },
          {
            id: 4,
            index: "04",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "数据导入"
          },
          {
            id: 5,
            index: "05",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "来款认单"
          },
          {
            id: 6,
            index: "06",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          },
          {
            id: 7,
            index: "07",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          },
          {
            id: 8,
            index: "08",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          }
        ], [
          {
            id: 1,
            index: "01",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "5日",
            advance: "提前",
            state: "未导入"
          },
          {
            id: 2,
            index: "02",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: " 数据导入"
          },
          {
            id: 3,
            index: "03",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "客户发票"
          },
          {
            id: 4,
            index: "04",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "数据导入"
          },
          {
            id: 5,
            index: "05",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "来款认单"
          },
          {
            id: 6,
            index: "06",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          },
          {
            id: 7,
            index: "07",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          },
          {
            id: 8,
            index: "08",
            name: "新传在线（北京）信息技术有限公司新传在线（北京）信息技术有限公司",
            time: "20日",
            advance: "提前",
            state: "支出单"
          }
        ]];
      // ——————————————————————————————
      this.$set(this, "pendingLists", pend);
      this.$set(this, "serviceList", serviceList);
      this.arryMenus();


    },
    created() {
      //查询设置的快捷菜单
      //this.getShortcutMenu();
     // this.cusIndustryClass();
    },
    data() {
      return {
        shortcutMenus: [],//快捷总菜单
        shortcutMenu: [],//快捷菜单
        pendingLists: [],//待处理
        serviceList: [],//待服务客户
        colorArr: ["#9825FD", "#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD", "#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD", "#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD", "#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD"],
        pieSize: ["50%", "70%"],
        pieValue: [],//"直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"
        pieData: [],//{ value: 335, name: "直接访问" },{ value: 310, name: "邮件营销" }, { value: 234, name: "联盟广告" }, { value: 135, name: "视频广告" },{ value: 1548, name: "搜索引擎" }
        setting: false,//快捷菜单设置
        zhezhao: false,//遮罩
        serviseActive: 0,//0今日 1本周 2本月
        memberId: "",
        pmsShortcutMenus: []
      };
    },
    methods:{
      end: function(ev){
        this.$set(this.shortcutMenu[ev.newIndex], "active", true);
        this.$set(this.shortcutMenu[ev.newIndex], "orderNum", ev.newIndex+1);
      },
      count: function(evt) {
        if(evt.relatedContext.list.length == 6){
          this.$alert("菜单数已满额！", "提醒", {
            confirmButtonText: "确定",
            callback: action => {
            }
          });
          return false;
        }
      },
      // 客户行业分类
      cusIndustryClass() {
        getIndustryClass().then(res => {
          // console.log("客户行业分类：",res);
          let data = res.data.data;
          let indust = [];
          let industName = [];
          data.forEach(item => {
            let value = item.value;
            let industryAprent = item.INDUSTRY_APRENT;
            let name = dictFilter(industryAprent, this.dicts);
            if (!name) {
              name = "没有分类的";
            }

            industName.push(name);
            indust.push({ "value": value, "name": name });
          });
          this.pieValue = industName;
          this.pieData = indust;
          this.$forceUpdate();
          //console.log("所有客户分类",this.pieValue);
          //console.log("所有的客户分类数量",this.pieData);
        });
      },
      /**
       * 快捷菜单点击事件
       * @param url
       */
      shortcutMenuClick(url) {
        this.$router.push({ path: url });
      },
      //查询出登录用户的快捷菜单
      getShortcutMenu() {
        this.memberId = this.memberInfo.id;
        getShortcutMenuByMemberId(this.memberId).then(res => {
          /// console.log("查询当前用用户的快捷菜单：===========",res);
          this.pmsShortcutMenus = res.data.data;
          //this.arryMenus();
          this.setShortcutMenu();
        });
      },
      // 设置快捷菜单
      setShortcutMenu() {
        // 如果查询出的用户没有设置快捷菜单则默认显示有权菜单的前三个
        let pmsMenus = new Array();
        // 1.先把显示快捷菜单设置为空
        this.$set(this, "shortcutMenu", []);
        // console.log("查询出用户设置的快捷菜单：",this.pmsShortcutMenus);
        // 2.设置显示快捷菜单值
        //存储已有快捷菜单
        if (this.pmsShortcutMenus && this.pmsShortcutMenus.length > 0) {
          this.shortcutMenus.forEach(item => {
            this.pmsShortcutMenus.forEach(i => {
              if (item.permission == i.menuCode && item.id == i.menuId) {
                item.active = true;
                item.orderNum = i.orderNum;
                pmsMenus.push(item);
              }
            });
          });
        } else {
          for (let i = 0; i < 3; i++) {
            this.shortcutMenus[i].active = true;
            pmsMenus.push(this.shortcutMenus[i]);
          }
        }
        const fastLists = this.shortcutMenus.filter(item => item.active == false )
        this.$set(this, "shortcutMenu", pmsMenus);
        this.$set(this, "shortcutMenus", fastLists);
      },
      // // 把子菜单和父菜单统一放到一个集合中
      arryMenus() {
        let arry = new Array();
        this.menu.forEach((item) => {
          if (item.id != 1 && item.id != 6) {
            this.recursionMenus(item, arry);
          }
        });
        this.shortcutMenus = arry;
        // console.table("所有的菜单",arry);
      },
      // 把菜单递归取出
      recursionMenus(menus, arry) {
        // 没有请求路径的不要
        if (menus.path) {
          menus.active = false;
          arry.push(menus);
        }
        if (menus.children) {
          // console.log("进入子菜单：",menus.children);
          menus.children.forEach((item) => {
            this.recursionMenus(item, arry);
          });
        }
        return arry;
      },
      isSetting() {
        this.setting = true;
        this.zhezhao = true;
      },
      saveSetting() {
        this.setting = false;
        this.zhezhao = false;
        let obj = {};
        obj.memberId = this.memberId;

        obj.shortcutMenu = this.shortcutMenu;
        saveShortcutMenu(obj).then(res => {
          // console.log("保存的结果:=====：===========",res);
          if (res.status == 200) {

            let data = res.data.data;
            if (data.success) {
              this.$message.success(data.msg);
            } else {
              this.$message.error("保存失败");
            }
          }
        });
      },
      cancelSetting() {
        this.setting = false;
        this.zhezhao = false;
      },
      changeTime(index) {
        this.serviseActive = index;
      },
      drawpie(dom, data, value, color, size, textColor) {
        let myChart = this.$echarts.init(document.getElementById(dom));
        const option = {
          color: color,
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            orient: "horizontal",
            x: "center",
            left: "center",
            itemGap: 20,
            bottom: 0,
            data: value,
            icon: "circle",
            itemWidth: 6,
            textStyle: {
              color: textColor
            }
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: size,
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false, position: "center"
                },
                emphasis: {
                  show: true, textStyle: { fontSize: "30", fontWeight: "bold" }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: data
            }
          ]
        };
        myChart.setOption(option);
      }
    },
    updated() {
      this.$nextTick(() => {
        this.drawpie("pie", this.pieData, this.pieValue, this.colorArr, this.pieSize, localStorage.getItem("Color"));
      });
    }
  };
</script>

<style lang="scss" scoped>

  .setting {

  }

  .shortSetTitle {
    padding-left: 10px;
  }

  .selectedItem {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .selectedItem li {
    padding-top: 20px;
    width: 88px;
    margin: 10px;
    height: 68px;
  }

  .selectedItem li.list-group-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
  }

  .selectedItem li .icon {
    color: #A5BFD8;
    font-size: 30px;
  }

  .selectedItem li .text {
    color: #000000;
    font-size: 12px;
    line-height: 40px;
  }

  .shortBox {
    display: flex;
  }

  .shortList {
    flex: 1;
  }

  .shortcut, .shortBtn {
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .shortcut .icon {
    font-size: 60px;
  }

  .shortcut span {
    font-size: 12px;
    line-height: 40px;
  }

  .shortBtn {
    width: 40px;
    margin-left: 34px;
    color: #6F7D93;
  }

  .shortBtn .icon {
    font-size: 38px;
  }

  .handler, .monitor {
    height: 350px;
    padding: 20px 30px;
  }

  @media screen and (max-width: 1460px) {
    .handler, .monitor {
      padding: 20px;
    }
  }

  .handleTitle {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
  }

  .handleTitle > div {
    display: flex;
    align-items: center;
  }

  .handleTitle-center .active {

    opacity: 1;
  }

  .handleTitle .icon {
    font-size: 20px;
    margin-left: 5px;
  }

  .handleTitle-right > div {
    display: flex;
    align-items: center;
  }

  .handleTitle-right .state {
    margin-left: 10px;
  }

  .handleTitle-right .state .icon {
    margin-left: 10px;
    font-size: 24px;
  }

  .stageBox h2 {
    font-size: 28px;
    text-align: center;
    line-height: 60px;
  }

  .stageList {
    display: flex;
  }

  .stageList .stage {
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .stageList .stage h3 {
    font-size: 40px;
    color: #FF6801;
    text-align: center;
    line-height: 60px;
  }

  .stageList .stage span {
    font-size: 12px;
    text-align: center;
  }

  .stageName {
    margin-top: 14px;
  }

  .stageDetail p {
    line-height: 36px;
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }

  .stageDetail .stageList {
    height: 8px;
    width: 100%;
    margin: 28px 0 28px 0;
  }

  .stageDetail .stageList:last-child {
    margin-bottom: 10px;
  }

  .stageEnd {
    width: 100%;
    height: 8px;
    display: flex;
  }

  .stagePass {
    width: 20%;
    height: 100%;
  }

  .stagepend {
    width: 20%;
    height: 100%;
    border-radius: 0 3.5px 3.5px 0;
    background: linear-gradient(to right, #FE9109, #FF6701)
  }

  .monitor .icon {
    font-size: 16px;
  }

  .monitorList {
    display: flex;
    align-items: center;
  }

  .monitorIcon {
    font-size: 24px;
    margin-right: 10px;
    background: #3470F6;
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    line-height: 24px;
    text-align: center;
  }

  .monitorDetail {
    margin-bottom: 4px;
    cursor: pointer;
  }

  .monitorDetail .mDTop {
    font-size: 14px;
    line-height: 22px;
  }

  .monitorDetail .mDTop span {
    font-size: 24px;
    color: #FD6A02;
  }

  .monitorDetail .mDBottom {
    font-size: 12px;
    line-height: 22px;
  }

  .handleBtn {
    text-align: center;
    line-height: 50px;
  }

  .handleBtn span {
    cursor: pointer;
    width: 40px;
    display: inline-block;
  }

  .serviceList {

  }

  .serviceBox, .charts {
    height: 390px;
  }

  .service {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    line-height: 30px;
    margin-top: 12px;
  }

  .service {
    padding: 0 10px;
  }

  .serviceName {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .charts {
    display: flex;
    flex-direction: column;
  }

  .chart {
    flex: 1;
    height: 100%;
  }


</style>





















